import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertMsgComponent } from './alert-msg/alert-msg.component';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { HeaderComponent } from './header/header.component';
import { ModalComponent } from './modal/modal.component';
import { PaginationComponent } from './pagination/pagination.component';
import { SmsPolicyModalComponent } from './sms-policy-modal/sms-policy-modal.component';
import { CloseIconComponent } from './close-icon/close-icon.component';
import { LanguageSelectComponent } from './language-select/language-select.component';
import { FlightCardComponent } from './flight-card/flight-card.component';
import { FlightCardContainerComponent } from './flight-card-container/flight-card-container.component';
import { HelpOptionsFormComponent } from './help-options-form/help-options-form.component';
import { SendBoardingpassModalComponent } from './send-boardingpass-modal/send-boardingpass-modal.component';
import { BoardingPassViewerComponent } from './boarding-pass-viewer/boarding-pass-viewer.component';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BoardingPassButtonComponent } from './boarding-pass-button/boarding-pass-button.component';
import { DummyWidgetComponent } from './dummy-widget/dummy-widget.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { SurveyComponent } from './survey/survey.component';
import { TimeoutModalComponent } from './timeout-modal/timeout-modal.component';
import { FeedbackWidgetComponent } from './feedback-widget/feedback-widget.component';
import { SurveyWidgetComponent } from './survey-widget/survey-widget.component';


@NgModule({
  declarations: [
    AlertMsgComponent,
    CookieConsentComponent,
    HeaderComponent,
    ModalComponent,
    PaginationComponent,
    SmsPolicyModalComponent,
    CloseIconComponent,
    LanguageSelectComponent,
    FlightCardComponent,
    FlightCardContainerComponent,
    HelpOptionsFormComponent,
    SendBoardingpassModalComponent,
    BoardingPassViewerComponent,
    BoardingPassButtonComponent,
    DummyWidgetComponent,
    FeedbackComponent,
    FeedbackWidgetComponent,
    TimeoutModalComponent,
    SurveyComponent,
    SurveyWidgetComponent,
  ],
  imports: [
    CommonModule,
    TextMaskModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
  ],
  exports: [
    AlertMsgComponent,
    CookieConsentComponent,
    HeaderComponent,
    ModalComponent,
    PaginationComponent,
    SmsPolicyModalComponent,
    CloseIconComponent,
    LanguageSelectComponent,
    FlightCardComponent,
    FlightCardContainerComponent,
    HelpOptionsFormComponent,
    SendBoardingpassModalComponent,
    BoardingPassViewerComponent,
    BoardingPassButtonComponent,
    DummyWidgetComponent,
    FeedbackComponent,
    FeedbackWidgetComponent,
    TimeoutModalComponent,
    SurveyComponent,
    SurveyWidgetComponent,
  ]
})
export class SharedModule { }
